import {environment} from "../aws/environment";

export const BUCKETS = {
    cdn: "r3z-cdn-us",
    s3: environment.COMPILE_BUCKET,
    local: null
};
